var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-card",
        [
          _c(
            "el-page-header",
            { staticClass: "align-items-start mb-3", on: { back: _vm.goBack } },
            [
              _c(
                "div",
                {
                  staticClass:
                    "d-flex flex-wrap align-items-start justify-content-between",
                  attrs: { slot: "content" },
                  slot: "content"
                },
                [
                  _c("div", { staticClass: "d-flex flex-column" }, [
                    _c("h5", { staticClass: "mb-1" }, [
                      _vm._v(_vm._s(_vm.getJuridicPerson.razao_social))
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "d-flex align-items-center",
                        style: { gap: "8px" }
                      },
                      [
                        _vm.getJuridicPerson.cnpj
                          ? _c("small", [
                              _c("strong", [_vm._v("CNPJ: ")]),
                              _vm._v(_vm._s(_vm.getJuridicPerson.cnpj))
                            ])
                          : _vm._e()
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "d-flex align-items-center",
                      style: { gap: "8px" }
                    },
                    [
                      _vm.prospect.tipo_cadastro
                        ? _c(
                            "el-tag",
                            {
                              staticClass: "rounded-pill",
                              attrs: {
                                type:
                                  _vm.prospect.tipo_cadastro == "NOVO"
                                    ? "success"
                                    : _vm.prospect.status == "REATIVACAO"
                                    ? "primary"
                                    : "warning"
                              }
                            },
                            [
                              _c("i", {
                                class:
                                  _vm.prospect.tipo_cadastro == "NOVO"
                                    ? "el-icon-finished"
                                    : _vm.prospect.status == "REATIVACAO"
                                    ? "el-icon-refresh"
                                    : "el-icon-connection"
                              }),
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.prospect.tipo_cadastro) +
                                  "\n                  "
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("el-divider", { attrs: { direction: "vertical" } }),
                      _vm._v(" "),
                      _vm.prospect.status
                        ? _c(
                            "el-tag",
                            {
                              attrs: {
                                type:
                                  _vm.prospect.status == "ATIVO"
                                    ? "success"
                                    : _vm.prospect.status == "DIGITADO"
                                    ? "primary"
                                    : _vm.prospect.status == "PRE_CADASTRO"
                                    ? "info"
                                    : _vm.prospect.status == "PENDENTE"
                                    ? "warning"
                                    : "danger"
                              }
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.prospect.status) +
                                  "\n                  "
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.prospect.created_at
                        ? _c("el-tag", { attrs: { type: "info" } }, [
                            _c(
                              "div",
                              { staticClass: "d-flex align-items-center" },
                              [
                                _c("i", { staticClass: "el-icon-time mr-2" }),
                                _vm._v(
                                  "\n                      " +
                                    _vm._s(
                                      _vm.formatDate(_vm.prospect.created_at)
                                    ) +
                                    "\n                    "
                                )
                              ]
                            )
                          ])
                        : _vm._e()
                    ],
                    1
                  )
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "el-tabs",
            {
              attrs: { type: "border-card" },
              model: {
                value: _vm.activeName,
                callback: function($$v) {
                  _vm.activeName = $$v
                },
                expression: "activeName"
              }
            },
            [
              _c(
                "el-tab-pane",
                { attrs: { name: "first" } },
                [
                  _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                    _c("i", { staticClass: "el-icon-office-building" }),
                    _vm._v(" "),
                    _c("span", { staticClass: "ml-1" }, [_vm._v("Empresa")])
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-descriptions",
                            {
                              staticClass: "my-3",
                              attrs: {
                                title: "Dados",
                                column: 6,
                                size: "mini",
                                border: true
                              }
                            },
                            [
                              _c(
                                "el-descriptions-item",
                                { attrs: { span: 6 } },
                                [
                                  _c("template", { slot: "label" }, [
                                    _vm._v("Razão Social")
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex align-items-center justify-content-between"
                                    },
                                    [
                                      _vm.getJuridicPerson.razao_social
                                        ? _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.getJuridicPerson
                                                  .razao_social
                                              )
                                            )
                                          ])
                                        : _c("span", [_vm._v("-")])
                                    ]
                                  )
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _c(
                                "el-descriptions-item",
                                { attrs: { span: 6 } },
                                [
                                  _c("template", { slot: "label" }, [
                                    _vm._v("Nome Fantasia")
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex align-items-center justify-content-between"
                                    },
                                    [
                                      _vm.getJuridicPerson.nome_fantasia
                                        ? _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.getJuridicPerson
                                                  .nome_fantasia
                                              )
                                            )
                                          ])
                                        : _c("span", [_vm._v("-")])
                                    ]
                                  )
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _vm.getFisicPerson
                                ? _c(
                                    "el-descriptions-item",
                                    { attrs: { span: 6 } },
                                    [
                                      _c("template", { slot: "label" }, [
                                        _vm._v("CPF")
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex align-items-center justify-content-between"
                                        },
                                        [
                                          _c(
                                            "div",
                                            [
                                              _vm.isLoading
                                                ? _c("el-skeleton")
                                                : _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.getFisicPerson
                                                          .cpf || "-"
                                                      )
                                                    )
                                                  ])
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _vm.getFisicPerson.cpf
                                            ? _c(
                                                "el-button",
                                                {
                                                  attrs: {
                                                    size: "mini",
                                                    circle: ""
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.copyThis(
                                                        _vm.getFisicPerson.cpf
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "el-icon-document-copy"
                                                  })
                                                ]
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      )
                                    ],
                                    2
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.getJuridicPerson
                                ? _c(
                                    "el-descriptions-item",
                                    { attrs: { span: 6 } },
                                    [
                                      _c("template", { slot: "label" }, [
                                        _vm._v("CNPJ")
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex align-items-center justify-content-between"
                                        },
                                        [
                                          _vm._v(
                                            "\n                              " +
                                              _vm._s(
                                                _vm.getJuridicPerson.cnpj || "-"
                                              ) +
                                              "\n                              "
                                          ),
                                          _vm.getJuridicPerson.cnpj
                                            ? _c(
                                                "el-button",
                                                {
                                                  attrs: {
                                                    size: "mini",
                                                    circle: ""
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.copyThis(
                                                        _vm.getJuridicPerson
                                                          .cnpj
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "el-icon-document-copy"
                                                  })
                                                ]
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      )
                                    ],
                                    2
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "el-descriptions-item",
                                { attrs: { span: 6 } },
                                [
                                  _c("template", { slot: "label" }, [
                                    _vm._v("Inscrição Estadual")
                                  ]),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.getJuridicPerson
                                          .inscricao_estadual || "-"
                                      )
                                    )
                                  ])
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _c(
                                "el-descriptions-item",
                                { attrs: { span: 3 } },
                                [
                                  _c("template", { slot: "label" }, [
                                    _vm._v("Cadastro Mei")
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "el-tag",
                                    {
                                      attrs: {
                                        size: "mini",
                                        type: _vm.getJuridicPerson.cadastro_mei
                                          ? "success"
                                          : "info"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                          " +
                                          _vm._s(
                                            _vm.getJuridicPerson.cadastro_mei
                                              ? "Sim"
                                              : "Não"
                                          ) +
                                          "\n                        "
                                      )
                                    ]
                                  )
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _c(
                                "el-descriptions-item",
                                { attrs: { span: 3 } },
                                [
                                  _c("template", { slot: "label" }, [
                                    _vm._v("Assinado Gov")
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "el-tag",
                                    {
                                      attrs: {
                                        size: "mini",
                                        type: _vm.getJuridicPerson.assinado_gov
                                          ? "success"
                                          : "info"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                          " +
                                          _vm._s(
                                            _vm.getJuridicPerson.assinado_gov
                                              ? "Sim"
                                              : "Não"
                                          ) +
                                          "\n                        "
                                      )
                                    ]
                                  )
                                ],
                                2
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-descriptions",
                            {
                              staticClass: "my-3",
                              attrs: {
                                title: "Informações de cadastro",
                                column: 6,
                                size: "mini",
                                border: true
                              }
                            },
                            [
                              _c(
                                "el-descriptions-item",
                                { attrs: { span: 6, label: "Classe" } },
                                [
                                  _vm.prospect.classe_distribuidor
                                    ? _c(
                                        "el-tag",
                                        {
                                          attrs: {
                                            size: "small",
                                            type: "primary"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.prospect.classe_distribuidor
                                            )
                                          )
                                        ]
                                      )
                                    : _c(
                                        "el-tag",
                                        {
                                          attrs: { size: "small", type: "info" }
                                        },
                                        [_vm._v("Sem atribuição")]
                                      )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-descriptions-item",
                                {
                                  attrs: {
                                    span: 6,
                                    label: "Centro de Distribuição"
                                  }
                                },
                                [
                                  _vm.cd
                                    ? _c(
                                        "el-tag",
                                        {
                                          attrs: {
                                            size: "small",
                                            type: "success"
                                          }
                                        },
                                        [_vm._v(_vm._s(_vm.cd.descricao))]
                                      )
                                    : _c(
                                        "el-tag",
                                        {
                                          attrs: { size: "small", type: "info" }
                                        },
                                        [_vm._v("Sem atribuição")]
                                      )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-descriptions-item",
                                { attrs: { span: 6, label: "Regiões" } },
                                [
                                  _vm.getRegion
                                    ? _c(
                                        "el-tag",
                                        {
                                          attrs: { size: "small", type: "info" }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.getRegion.descricao)
                                          )
                                        ]
                                      )
                                    : _c(
                                        "el-tag",
                                        {
                                          attrs: { size: "small", type: "info" }
                                        },
                                        [_vm._v("Sem atribuição")]
                                      )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.prospect.codigo_anterior
                                ? _c(
                                    "el-descriptions-item",
                                    {
                                      attrs: {
                                        span: 6,
                                        label: "Código Anterior"
                                      }
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.prospect.codigo_anterior)
                                        )
                                      ])
                                    ]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-tab-pane",
                { attrs: { name: "second" } },
                [
                  _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                    _c("i", { staticClass: "el-icon-location-outline" }),
                    _vm._v(" "),
                    _c("span", { staticClass: "ml-1" }, [_vm._v("Endereços")])
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-descriptions",
                            {
                              staticClass: "my-3",
                              attrs: {
                                title: "Endereço principal",
                                column: 4,
                                size: "small",
                                border: true
                              }
                            },
                            [
                              _c("template", { slot: "extra" }, [
                                _vm.getPrincipalAddress == null
                                  ? _c(
                                      "div",
                                      [
                                        _c(
                                          "el-tag",
                                          {
                                            attrs: {
                                              size: "mini",
                                              type: "info"
                                            }
                                          },
                                          [_vm._v("Não cadastrado")]
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ]),
                              _vm._v(" "),
                              _c(
                                "el-descriptions-item",
                                { attrs: { span: 4, label: "CEP" } },
                                [
                                  _vm.getPrincipalAddress &&
                                  _vm.getPrincipalAddress.cep
                                    ? _c("span", [
                                        _vm._v(
                                          "\n                          " +
                                            _vm._s(
                                              _vm.getPrincipalAddress.cep
                                            ) +
                                            "\n                        "
                                        )
                                      ])
                                    : _c("span", [_vm._v("-")])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-descriptions-item",
                                { attrs: { span: 4, label: "Logradouro" } },
                                [
                                  _vm.getPrincipalAddress &&
                                  _vm.getPrincipalAddress.logradouro
                                    ? _c("span", [
                                        _vm._v(
                                          "\n                          " +
                                            _vm._s(
                                              _vm.getPrincipalAddress.logradouro
                                            ) +
                                            "\n                        "
                                        )
                                      ])
                                    : _c("span", [_vm._v("-")])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-descriptions-item",
                                { attrs: { span: 4, label: "Complemento" } },
                                [
                                  _vm.getPrincipalAddress &&
                                  _vm.getPrincipalAddress.complemento
                                    ? _c("span", [
                                        _vm._v(
                                          "\n                          " +
                                            _vm._s(
                                              _vm.getPrincipalAddress
                                                .complemento
                                            ) +
                                            "\n                        "
                                        )
                                      ])
                                    : _c("span", [_vm._v("-")])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-descriptions-item",
                                { attrs: { span: 4, label: "Bairro" } },
                                [
                                  _vm.getPrincipalAddress &&
                                  _vm.getPrincipalAddress.bairro
                                    ? _c("span", [
                                        _vm._v(
                                          "\n                          " +
                                            _vm._s(
                                              _vm.getPrincipalAddress.bairro
                                            ) +
                                            "\n                        "
                                        )
                                      ])
                                    : _c("span", [_vm._v("-")])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-descriptions-item",
                                { attrs: { span: 2, label: "Estado" } },
                                [
                                  _vm.getPrincipalAddress &&
                                  _vm.getPrincipalAddress.cidade &&
                                  _vm.getPrincipalAddress.cidade.estado
                                    ? _c("span", [
                                        _vm._v(
                                          "\n                          " +
                                            _vm._s(
                                              _vm.getPrincipalAddress.cidade
                                                .estado.uf
                                            ) +
                                            "\n                        "
                                        )
                                      ])
                                    : _c("span", [_vm._v("-")])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-descriptions-item",
                                { attrs: { span: 2, label: "Cidade" } },
                                [
                                  _vm.getPrincipalAddress &&
                                  _vm.getPrincipalAddress.cidade
                                    ? _c("span", [
                                        _vm._v(
                                          "\n                          " +
                                            _vm._s(
                                              _vm.getPrincipalAddress.cidade
                                                .nome
                                            ) +
                                            "\n                        "
                                        )
                                      ])
                                    : _c("span", [_vm._v("-")])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-descriptions-item",
                                {
                                  attrs: {
                                    span: 4,
                                    label: "Instruções de Entrega"
                                  }
                                },
                                [
                                  _vm.getPrincipalAddress &&
                                  _vm.getPrincipalAddress.instrucao_entrega
                                    ? _c("span", [
                                        _vm._v(
                                          "\n                          " +
                                            _vm._s(
                                              _vm.getPrincipalAddress
                                                .instrucao_entrega
                                            ) +
                                            "\n                        "
                                        )
                                      ])
                                    : _c("span", [_vm._v("-")])
                                ]
                              )
                            ],
                            2
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-descriptions",
                            {
                              staticClass: "my-3",
                              attrs: {
                                title: "Endereço de entrega",
                                column: 4,
                                size: "small",
                                border: true
                              }
                            },
                            [
                              _c("template", { slot: "extra" }, [
                                _vm.getDeliveryAddress == null
                                  ? _c(
                                      "div",
                                      [
                                        _c(
                                          "el-tag",
                                          {
                                            attrs: {
                                              size: "mini",
                                              type: "info"
                                            }
                                          },
                                          [_vm._v("Não cadastrado")]
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ]),
                              _vm._v(" "),
                              _c(
                                "el-descriptions-item",
                                { attrs: { span: 4, label: "CEP" } },
                                [
                                  _vm.getDeliveryAddress &&
                                  _vm.getDeliveryAddress.cep
                                    ? _c("span", [
                                        _vm._v(
                                          "\n                          " +
                                            _vm._s(_vm.getDeliveryAddress.cep) +
                                            "\n                        "
                                        )
                                      ])
                                    : _c("span", [_vm._v("-")])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-descriptions-item",
                                { attrs: { span: 4, label: "Logradouro" } },
                                [
                                  _vm.getDeliveryAddress &&
                                  _vm.getDeliveryAddress.logradouro
                                    ? _c("span", [
                                        _vm._v(
                                          "\n                          " +
                                            _vm._s(
                                              _vm.getDeliveryAddress.logradouro
                                            ) +
                                            "\n                        "
                                        )
                                      ])
                                    : _c("span", [_vm._v("-")])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-descriptions-item",
                                { attrs: { span: 4, label: "Complemento" } },
                                [
                                  _vm.getDeliveryAddress &&
                                  _vm.getDeliveryAddress.complemento
                                    ? _c("span", [
                                        _vm._v(
                                          "\n                          " +
                                            _vm._s(
                                              _vm.getDeliveryAddress.complemento
                                            ) +
                                            "\n                        "
                                        )
                                      ])
                                    : _c("span", [_vm._v("-")])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-descriptions-item",
                                { attrs: { span: 4, label: "Bairro" } },
                                [
                                  _vm.getDeliveryAddress &&
                                  _vm.getDeliveryAddress.bairro
                                    ? _c("span", [
                                        _vm._v(
                                          "\n                          " +
                                            _vm._s(
                                              _vm.getDeliveryAddress.bairro
                                            ) +
                                            "\n                        "
                                        )
                                      ])
                                    : _c("span", [_vm._v("-")])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-descriptions-item",
                                { attrs: { span: 2, label: "Estado" } },
                                [
                                  _vm.getDeliveryAddress &&
                                  _vm.getDeliveryAddress.cidade &&
                                  _vm.getDeliveryAddress.cidade.estado
                                    ? _c("span", [
                                        _vm._v(
                                          "\n                          " +
                                            _vm._s(
                                              _vm.getDeliveryAddress.cidade
                                                .estado.uf
                                            ) +
                                            "\n                        "
                                        )
                                      ])
                                    : _c("span", [_vm._v("-")])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-descriptions-item",
                                { attrs: { span: 2, label: "Cidade" } },
                                [
                                  _vm.getDeliveryAddress &&
                                  _vm.getDeliveryAddress.cidade
                                    ? _c("span", [
                                        _vm._v(
                                          "\n                          " +
                                            _vm._s(
                                              _vm.getDeliveryAddress.cidade.nome
                                            ) +
                                            "\n                        "
                                        )
                                      ])
                                    : _c("span", [_vm._v("-")])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-descriptions-item",
                                {
                                  attrs: {
                                    span: 4,
                                    label: "Instruções de Entrega"
                                  }
                                },
                                [
                                  _vm.getDeliveryAddress &&
                                  _vm.getDeliveryAddress.instrucao_entrega
                                    ? _c("span", [
                                        _vm._v(
                                          "\n                          " +
                                            _vm._s(
                                              _vm.getDeliveryAddress
                                                .instrucao_entrega
                                            ) +
                                            "\n                        "
                                        )
                                      ])
                                    : _c("span", [_vm._v("-")])
                                ]
                              )
                            ],
                            2
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-tab-pane",
                { attrs: { name: "third" } },
                [
                  _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                    _c("i", { staticClass: "el-icon-phone-outline" }),
                    _vm._v(" "),
                    _c("span", { staticClass: "ml-1" }, [_vm._v("Contatos")])
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    [
                      _vm.getContacts && _vm.getContacts.length > 0
                        ? _c(
                            "el-descriptions",
                            {
                              staticClass: "my-3",
                              attrs: {
                                title: "Contatos",
                                column: 4,
                                border: true
                              }
                            },
                            [
                              _c("template", { slot: "extra" }, [
                                _c(
                                  "div",
                                  { staticClass: "d-flex align-items-center" },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          size: "mini",
                                          type: "warning",
                                          plain: "",
                                          title: "Consulta manual LEMIT",
                                          disabled: _vm.isLoading
                                        },
                                        nativeOn: {
                                          click: function($event) {
                                            $event.preventDefault()
                                            return _vm.handleConsultLemit()
                                          }
                                        }
                                      },
                                      [
                                        _vm.isLoading
                                          ? _c("i", {
                                              staticClass: "el-icon-loading"
                                            })
                                          : _c("i", {
                                              staticClass: "el-icon-right"
                                            }),
                                        _vm._v(
                                          "\n                          Realizar consulta LEMIT\n                      "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ]),
                              _vm._v(" "),
                              _vm._l(_vm.getContacts, function(contact, index) {
                                return _c(
                                  "el-descriptions-item",
                                  { key: contact.id, attrs: { span: 2 } },
                                  [
                                    contact.telefone
                                      ? _c("template", { slot: "label" }, [
                                          _vm._v(
                                            "\n                            " +
                                              _vm._s(
                                                contact.telefone.tipo == "F"
                                                  ? "Fixo"
                                                  : "Celular"
                                              ) +
                                              "\n                        "
                                          )
                                        ])
                                      : _c("template", { slot: "label" }, [
                                          _vm._v("Telefone não informado")
                                        ]),
                                    _vm._v(" "),
                                    contact.telefone
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-flex align-items-center justify-content-between"
                                          },
                                          [
                                            _c("h6", { staticClass: "mb-0" }, [
                                              _vm._v(
                                                "(" +
                                                  _vm._s(contact.telefone.ddd) +
                                                  ") " +
                                                  _vm._s(
                                                    contact.telefone.numero
                                                  )
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              [
                                                contact.telefone.whatsapp
                                                  ? _c(
                                                      "el-button",
                                                      {
                                                        style: {
                                                          pointerEvents: "none",
                                                          cursor: "auto"
                                                        },
                                                        attrs: {
                                                          size: "small",
                                                          type: "success",
                                                          circle: ""
                                                        }
                                                      },
                                                      [_c("BIconWhatsapp")],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _c(
                                                  "el-button",
                                                  {
                                                    attrs: {
                                                      size: "small",
                                                      circle: ""
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        _vm.copyThis(
                                                          "(" +
                                                            contact.ddd +
                                                            ")$ {contact.numero}"
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "el-icon-document-copy"
                                                    })
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ],
                                  2
                                )
                              })
                            ],
                            2
                          )
                        : _c(
                            "div",
                            [
                              _c("span", [_c("strong", [_vm._v("Contatos")])]),
                              _vm._v(" "),
                              _c("el-empty", {
                                attrs: {
                                  description: "Nenhuma contato atribuido"
                                }
                              })
                            ],
                            1
                          )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-tab-pane",
                { attrs: { name: "fourth" } },
                [
                  _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                    _c("i", { staticClass: "el-icon-setting" }),
                    _vm._v(" "),
                    _c("span", { staticClass: "ml-1" }, [
                      _vm._v("Configurações")
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-descriptions",
                            {
                              attrs: {
                                title: "Financeiro",
                                column: 4,
                                size: "small",
                                border: true
                              }
                            },
                            [
                              _c(
                                "el-descriptions-item",
                                {
                                  attrs: { span: 4, label: "Via de Pagamento" }
                                },
                                [
                                  _vm.prospect.pagamento
                                    ? _c("span", [
                                        _vm._v(_vm._s(_vm.prospect.pagamento))
                                      ])
                                    : _c("span", [_vm._v("-")])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-descriptions-item",
                                {
                                  attrs: { span: 4, label: "Limite de Crédito" }
                                },
                                [
                                  _vm.prospect.limite_credito
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.prospect.limite_credito)
                                        )
                                      ])
                                    : _c("span", [_vm._v("-")])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-descriptions-item",
                                {
                                  attrs: {
                                    span: 4,
                                    label: "Prazo p/ pagamento"
                                  }
                                },
                                [
                                  _vm.prospect.prazo_pagamento != null
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.prospect.prazo_pagamento)
                                        )
                                      ])
                                    : _c("span", [_vm._v("-")])
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("el-col", { attrs: { span: 12 } }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "pt-1 d-flex align-items-center justify-content-between mb-3"
                          },
                          [
                            _c("h6", { staticClass: "font-weight-bold mb-0" }, [
                              _vm._v("Kits")
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              _vm._l(_vm.getKits, function(kit) {
                                return _c(
                                  "el-tag",
                                  {
                                    key: kit.text,
                                    staticClass: "mr-1",
                                    style: { opacity: kit.value ? "1" : "0.5" },
                                    attrs: {
                                      size: "small",
                                      type: kit.value ? "primary" : "info"
                                    }
                                  },
                                  [
                                    kit.value
                                      ? _c("i", {
                                          staticClass: "el-icon-circle-check"
                                        })
                                      : _vm._e(),
                                    _vm._v(
                                      "\n                        " +
                                        _vm._s(kit.text) +
                                        "\n                      "
                                    )
                                  ]
                                )
                              }),
                              1
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "d-flex align-items-center justify-content-between mb-3"
                          },
                          [
                            _c("h6", { staticClass: "font-weight-bold mb-0" }, [
                              _vm._v("Revendedoras")
                            ]),
                            _vm._v(" "),
                            _c(
                              "el-tag",
                              { attrs: { type: "primary", size: "small" } },
                              [_vm._v(_vm._s(_vm.prospect.qtd_revendedoras))]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "d-flex align-items-center justify-content-between mb-3"
                          },
                          [
                            _c("h6", { staticClass: "font-weight-bold mb-0" }, [
                              _vm._v("Catálogos")
                            ]),
                            _vm._v(" "),
                            _c(
                              "el-tag",
                              { attrs: { type: "primary", size: "small" } },
                              [_vm._v(_vm._s(_vm.prospect.qtd_catalogo))]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "d-flex align-items-center justify-content-between"
                          },
                          [
                            _c("h6", { staticClass: "font-weight-bold mb-0" }, [
                              _vm._v("Código Cadastro Matriz")
                            ]),
                            _vm._v(" "),
                            _vm.getMatriz
                              ? _c(
                                  "el-tag",
                                  { attrs: { type: "primary", size: "small" } },
                                  [_vm._v(_vm._s(_vm.getMatriz.codigo))]
                                )
                              : _c(
                                  "el-tag",
                                  { attrs: { type: "warning", size: "small" } },
                                  [_vm._v("Sem associação")]
                                )
                          ],
                          1
                        )
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("el-tab-pane", { attrs: { name: "fifth" } }, [
                _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                  _c("i", { staticClass: "el-icon-folder" }),
                  _vm._v(" "),
                  _c("span", { staticClass: "ml-1" }, [_vm._v("Anexos")])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  [_c("Anexos", { attrs: { prospect: _vm.prospect } })],
                  1
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-tabs",
            {
              staticClass: "mt-3",
              attrs: { "tab-position": "left" },
              model: {
                value: _vm.activeInfo,
                callback: function($$v) {
                  _vm.activeInfo = $$v
                },
                expression: "activeInfo"
              }
            },
            [
              _c("el-tab-pane", { attrs: { name: "second" } }, [
                _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                  _c("i", { staticClass: "el-icon-chat-line-square" }),
                  _vm._v(" "),
                  _c("span", { staticClass: "ml-1" }, [_vm._v("Observações")])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "rounded border p-3" },
                  [
                    _vm.getObservations && _vm.getObservations.length > 0
                      ? _c(
                          "el-timeline",
                          _vm._l(_vm.getObservations, function(obs, index) {
                            return _c(
                              "el-timeline-item",
                              {
                                key: obs.id,
                                attrs: {
                                  timestamp: obs.created_at,
                                  placement: "top",
                                  color: "#0bbd87"
                                }
                              },
                              [
                                _c("el-card", [
                                  _c(
                                    "p",
                                    {
                                      staticClass: "mb-0",
                                      style: { fontSize: "14px" }
                                    },
                                    [_vm._v(_vm._s(obs.observacao))]
                                  )
                                ])
                              ],
                              1
                            )
                          }),
                          1
                        )
                      : _c("el-empty", {
                          attrs: {
                            description: "Nenhuma observação encontrada"
                          }
                        })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("el-tab-pane", { attrs: { name: "first" } }, [
                _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                  _c("i", { staticClass: "el-icon-timer" }),
                  _vm._v(" "),
                  _c("span", { staticClass: "ml-1" }, [_vm._v("Histórico")])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "rounded border p-3" },
                  [
                    _vm.getHistoric && _vm.getHistoric.length > 0
                      ? _c(
                          "el-timeline",
                          _vm._l(_vm.getHistoric, function(historic, index) {
                            return _c(
                              "el-timeline-item",
                              {
                                key: historic.id,
                                attrs: {
                                  timestamp: _vm.formatDate(
                                    historic.created_at,
                                    true
                                  ),
                                  placement: "top",
                                  color:
                                    historic.origem == "LEMIT"
                                      ? "#e6a23c"
                                      : "#0bbd87"
                                }
                              },
                              [
                                _c("el-card", { staticClass: "mb-2" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex align-items-center justify-content-between",
                                      style: { gap: "12px" }
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "flex-grow-1" },
                                        [
                                          _c("span", [
                                            _c("strong", [
                                              _vm._v(_vm._s(historic.titulo))
                                            ])
                                          ])
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-tag",
                                        {
                                          attrs: {
                                            type: _vm.typeProspectHistoric(
                                              historic.origem
                                            )
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                        " +
                                              _vm._s(historic.origem) +
                                              "\n                      "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  historic.origem == "LEMIT" &&
                                  historic.destino != "LEMIT_INVALIDO"
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "d-flex flex-column mt-2"
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "p-2 rounded d-flex align-items-center justify-content-between",
                                              style: {
                                                border: "1px dashed #dedede",
                                                gap: "12px"
                                              }
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "d-flex align-items-center",
                                                  style: { gap: "12px" }
                                                },
                                                [
                                                  _c(
                                                    "el-tag",
                                                    {
                                                      staticClass:
                                                        "rounded-circle",
                                                      attrs: { type: "success" }
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "el-icon-phone-outline"
                                                      })
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("div", [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "text-muted"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Número verificado"
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c("h6", [
                                                      _c("strong", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.maskPhoneNumber(
                                                              historic.descricao
                                                            )
                                                          )
                                                        )
                                                      ])
                                                    ])
                                                  ])
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "el-tag",
                                                {
                                                  attrs: {
                                                    type:
                                                      historic.destino ==
                                                      "LEMIT_CONFIRMADO"
                                                        ? "success"
                                                        : "danger",
                                                    size: "small",
                                                    effect: "dark"
                                                  }
                                                },
                                                [
                                                  historic.destino ==
                                                  "LEMIT_CONFIRMADO"
                                                    ? _c("span", [
                                                        _vm._v("CONFIRMADO")
                                                      ])
                                                    : _c(
                                                        "el-tooltip",
                                                        {
                                                          attrs: {
                                                            content:
                                                              "Este número não pode ser verificado via LEMIT, faça uma analíse manual ou realize uma nova consulta",
                                                            placement:
                                                              "bottom-start",
                                                            effect: "light"
                                                          }
                                                        },
                                                        [
                                                          _c("span", [
                                                            _vm._v(
                                                              "NÃO CONFIRMADO"
                                                            )
                                                          ])
                                                        ]
                                                      )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ]),
                                _vm._v(" "),
                                historic.user
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "d-flex align-items-center justify-content-end",
                                        style: { gap: "8px" }
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-flex align-items-center",
                                            style: { gap: "8px" }
                                          },
                                          [
                                            _c(
                                              "el-avatar",
                                              { attrs: { size: "small" } },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    historic.user.name.charAt(0)
                                                  )
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "d-flex flex-column"
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "font-weight-bold",
                                                    style: {
                                                      fontSize: "14px",
                                                      marginBottom: "-4px"
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(historic.user.name)
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass: "text-muted",
                                                    style: { fontSize: "14px" }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        historic.user.email
                                                      )
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          }),
                          1
                        )
                      : _c("el-empty", {
                          attrs: { description: "Nenhum histórico encontrado" }
                        })
                  ],
                  1
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticClass: "mt-3" },
            [
              _c("el-col", [
                _c(
                  "div",
                  {
                    staticClass: "d-flex align-items-center mb-2",
                    style: { gap: "8px" }
                  },
                  [
                    _c("i", { staticClass: "el-icon-edit-outline" }),
                    _vm._v("\n              Atuantes\n            ")
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "rounded border p-3" }, [
                  _c(
                    "div",
                    {
                      staticClass: "d-flex flex-column",
                      style: { gap: "12px" }
                    },
                    [
                      _vm.getUser
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "d-flex align-items-center justify-content-between",
                              style: { gap: "8px" }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "d-flex align-items-center",
                                  style: { gap: "8px" }
                                },
                                [
                                  _c(
                                    "el-avatar",
                                    { attrs: { size: "medium" } },
                                    [_vm._v(_vm._s(_vm.getUser.name.charAt(0)))]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "d-flex flex-column" },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "font-weight-bold",
                                          style: {
                                            fontSize: "14px",
                                            marginBottom: "-4px"
                                          }
                                        },
                                        [_vm._v(_vm._s(_vm.getUser.name))]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          staticClass: "text-muted",
                                          style: { fontSize: "14px" }
                                        },
                                        [_vm._v(_vm._s(_vm.getUser.email))]
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("el-tag", { attrs: { type: "success" } }, [
                                _vm._v("Criou o prospecto")
                              ])
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.getSaler
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "d-flex align-items-center justify-content-between",
                              style: { gap: "8px" }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "d-flex align-items-center",
                                  style: { gap: "8px" }
                                },
                                [
                                  _c(
                                    "el-avatar",
                                    { attrs: { size: "medium" } },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.getSaler.nome.charAt(0))
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "d-flex flex-column" },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "font-weight-bold",
                                          style: {
                                            fontSize: "14px",
                                            marginBottom: "-4px"
                                          }
                                        },
                                        [_vm._v(_vm._s(_vm.getSaler.nome))]
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("el-tag", { attrs: { type: "warning" } }, [
                                _vm._v("Vendedor")
                              ])
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.getCdIndic
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "d-flex align-items-center justify-content-between",
                              style: { gap: "8px" }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "d-flex align-items-center",
                                  style: { gap: "8px" }
                                },
                                [
                                  _c("el-avatar", {
                                    attrs: {
                                      size: "medium",
                                      icon: "el-icon-office-building"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "d-flex flex-column" },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "font-weight-bold",
                                          style: {
                                            fontSize: "14px",
                                            marginBottom: "-4px"
                                          }
                                        },
                                        [_vm._v(_vm._s(_vm.getCdIndic.nome))]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          staticClass: "text-muted",
                                          style: { fontSize: "14px" }
                                        },
                                        [_vm._v(_vm._s(_vm.getCdIndic.email))]
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("el-tag", { attrs: { type: "primary" } }, [
                                _vm._v("Distribuidor Indicante")
                              ])
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.getMatriz
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "d-flex align-items-center justify-content-between",
                              style: { gap: "8px" }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "d-flex align-items-center",
                                  style: { gap: "8px" }
                                },
                                [
                                  _c("el-avatar", {
                                    attrs: {
                                      size: "medium",
                                      icon: "el-icon-office-building"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "d-flex flex-column" },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "font-weight-bold",
                                          style: {
                                            fontSize: "14px",
                                            marginBottom: "-4px"
                                          }
                                        },
                                        [_vm._v(_vm._s(_vm.getMatriz.nome))]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          staticClass: "text-muted",
                                          style: { fontSize: "14px" }
                                        },
                                        [_vm._v(_vm._s(_vm.getMatriz.email))]
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("el-tag", { attrs: { type: "warning" } }, [
                                _vm._v("Matriz associada")
                              ])
                            ],
                            1
                          )
                        : _vm._e()
                    ]
                  )
                ])
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3e3bd4d5", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e3bd4d5","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/adm_prospecto/Show.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-3e3bd4d5","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/adm_prospecto/Show.vue
// module chunks = 2